import { RemitRecord } from "us.collection.economy/components/Remit/Interfaces";
import { NavigationOptions } from "../Interfaces";
import { DEFAULT_CREDITOR_DETAIL } from "../Constants";

/**
 * @description - return creditor list for the remit
 * @param {RemitRecord[]} remitRecord - Related remit record
 * @returns {NavigationOptions[]}
 */
export const getCreditorCaseList = (
  remitRecord: RemitRecord[]
): NavigationOptions[] => {
  try {
    if (Array.isArray(remitRecord)) {
      return remitRecord.map((record: RemitRecord) => ({
        label: record.creditorNo + " - " + record.creditorName,
        value: record.creditorNo,
      }));
    } else {
      return [];
    }
  } catch (error) {
    return [];
  }
};

/**
 * @description - return previous or next creditor number
 * @param {RemitRecord[]} remitRecord - Related remit record
 * @param { string } currentCreditorNo - current creditor number
 * @param { boolean } isNext - is next, 1 else 0
 * @returns {string}
 */
export const fetchCreditorNumber = (
  remitRecord: RemitRecord[],
  currentCreditorNo: string,
  isNext: boolean
): string => {
  try {
    if (
      Array.isArray(remitRecord) &&
      currentCreditorNo &&
      remitRecord.length > 0
    ) {
      const currentIndex = remitRecord.findIndex(
        (record: RemitRecord) => record.creditorNo === currentCreditorNo
      );
      if (currentIndex === -1) {
        return "";
      }
      if(isNext){
        if (currentIndex === remitRecord.length - 1) {
          return "";
        }
        return remitRecord[currentIndex + 1].creditorNo;
      }else{
        if (currentIndex === 0) {
          return "";
        }
        return remitRecord[currentIndex - 1].creditorNo;
      }
    } else {
      return "";
    }
  } catch (error) {
    return "";
  }
};

/**
 * @description - return creditor remit detail
 * @param {RemitRecord[]} remitRecord - Related remit record
 * @param {string} creditorNo - Creditor number
 * @returns {RemitRecord}
 */
export const getCreditorRemitDetails = (
  remitRecord: RemitRecord[],
  creditorNo: string
): RemitRecord => {
  try {
    if (Array.isArray(remitRecord) && remitRecord?.length > 0) {
      return remitRecord.filter(
        (record: RemitRecord) => record.creditorNo == creditorNo
      )[0];
    } else {
      return DEFAULT_CREDITOR_DETAIL;
    }
  } catch (error) {
    return DEFAULT_CREDITOR_DETAIL;
  }
};
